import Quill from 'quill/core';
import type QuillEditor from '../../QuillEditor';
import type { Blot } from '../../types';

function formatBlotWithoutScrolling({
  quill,
  blot,
  attributes,
}: {
  quill: QuillEditor;
  blot: Blot;
  attributes: Record<string, unknown>;
}) {
  const previousSelection = quill.getSelection();

  quill.focusWithoutScrolling();

  const index = blot.offset(quill.scroll);
  quill.setSelection(index, 1, Quill.sources.SILENT);
  Object.keys(attributes).forEach((name) => {
    quill.format(name, attributes[name], Quill.sources.USER);
  });

  quill.setSelection(previousSelection, Quill.sources.SILENT);
}

export default formatBlotWithoutScrolling;
